import { gql } from 'graphql-tag'

// Superset of CWA + CMA addressFields fragments.
// CWA adds: normalizedAddressId, consumerSpecifiedAddressNormalization, hours
// CMA adds: securityCode, images (both have these but listed for clarity)
export const addressFields = gql`
  fragment AddressFields on Address {
    addressId
    normalizedAddressId
    consumerSpecifiedAddressNormalization
    type
    name
    street
    apartment
    city
    state
    country
    zipCode
    attributes
    location {
      lat
      lng
    }
    instructions
    pickupInstructions
    preferredLocation
    preferredPickupLocation
    securityCode
    images {
      addressId
      createdAt
      imageType
      key
      meta
      tags
      location {
        lat
        lng
      }
      updatedAt
      imageUrl
    }
    hours {
      enabled
      dayHours {
        dayOfWeek
        openTime
        closeTime
        isClosed
      }
    }
  }
`
